/**
 * 判断url是否是http或https
 * @returns {Boolean}
 * @param url
 */
export const isHttp = (url) => {
  return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1;
};

// 是否为正确的电话号码格式
export const isValidPhone = (phone) =>{
  const landlineRegex = /^(0\d{2})[- ]?(\d{8})$/;
  const mobileRegex = /^1[3-9]\d{9}$/;
  return landlineRegex.test(phone) || mobileRegex.test(phone);
}
